
    export enum EnumStatementType {
			Both = 0,
			Electronic = 1,
			Paper = 2,
			Neither = 3,
    }